module.exports = __webpack_public_path__ + "static/media/Dashboard_Tour_Video.e73d5b9e.mp4";